const philosophy = [
    {
        "name": "Dreamism",
        "neurosis": "Sleepless",
        "neurosisDefinition": "You cannot sleep soundly unless you are at the feet of the Dream Keeper, bathed in the snores of the dreamers if holds afolt."+
                              "\nYou cannot gain survival during the hunt or showdown.",
        "tenet": "Guardian",
        "huntxp": [4,7,10],
        "type": "core",
        "flavor": "Who or what is the Dream Keeper"
    },
    {
        "name": "Impermanism",
        "neurosis": "Unrestrained",
        "neurosisDefinition": "It was always going to break. All your weapons, except Fist & Tooth, have Frail while they are in your gear grid."+
                              "\nIf you wound a Super-Dense hit location with Fist & Tooth, suffer the broken arm severe injury at the end of the attack.",
        "tenet": "Shatterstar",
        "huntxp": [4,7,10],
        "type": "one",
        "flavor": "Nothing Lasts Forever"
    },
    {
        "name": "Faceism",
        "neurosis": "Fixated",
        "neurosisDefinition": "You can attack the monster only from its facing or when it is knocked down.",
        "tenet": "Physiognomy",
        "huntxp": [4,7,10],
        "type": "one",
        "flavor": "In Every Place, A Face"
    },
    {
        "name": "Survivalism",
        "neurosis": "Selfish",
        "neurosisDefinition": "When you encourage another survivor, roll 1d10. On a 6+, you do not encourage. Keep your survival. You cannot encourage again this round."+
                              "\nIf it is possible for your survivor to use Meat Shield to avoid harm, they must use it.",
        "tenet": "Tenacity",
        "huntxp": [4,7,10],
        "type": "Starting",
        "flavor": "Live at All Costs"
    },
    {
        "name": "Deadism",
        "neurosis": "Disembodied",
        "neurosisDefinition": "Nothing matters. You cannot gain insanity.",
        "tenet": "Death Poet",
        "huntxp": [4,10,12],
        "type": "one",
        "flavor": "You are Already Dead"
    },
    {
        "name": "Lanternism",
        "neurosis": "Phototaxis",
        "neurosisDefinition": "You are bound by the light. While there is a Fallen Lantern terrain tile on the board, you cannot spend survival.",
        "tenet": "Death Collector",
        "huntxp": [4,7,10],
        "type": "one",
        "flavor": "The Dead Light the Way"
    },
    {
        "name": "Homicidalism",
        "neurosis": "Murderer",
        "neurosisDefinition": "During the hunt or showdown, if you are ever alone with another survivor, you murder them; keep track of your Body Count on your arc survivor record sheet. "+
                              "Before resolving each rank of Homicidalism, roll 1d10 and subtract your Body Count from the roll result. On a 1 or lower, the settlement kills you."+
                              "\nBody Count: The number of other survivors you have killed.",
        "tenet": "Dark Impulse",
        "huntxp": [6,10,14],
        "type": "Systemic",
        "flavor": "Live to Kill"
    },
    {
        "name": "Marrowism",
        "neurosis": "Arrogance",
        "neurosisDefinition": "WHy follow in any other footsteps? When you gain knowledge at the Forum that is not from Marrowism, it costs +2 lumi."+
                              "\nYou cannot refuse a Majestic invitation from a Bone Eater.",
        "tenet": "Osteophage",
        "huntxp": [6,10,14],
        "type": "systemic",
        "flavor": "Strength Under the Skin"
    },
    {
        "name": "Romanticism",
        "neurosis": "Dilettante",
        "neurosisDefinition": "When you depart, gain a random knowledge from the knowledge deck. If you have no empty knowledge slots, you must replace an existing knowledge.",
        "tenet": "Wanderlust",
        "huntxp": [6,10,14],
        "type": "systemic",
        "flavor": "All the Feels"
    },
    {
        "name": "Collectivism",
        "neurosis": "Selfless",
        "neurosisDefinition": "While you are alive, increase the settlement's survival limit by +1. Each Collectivist can increase the limit."+
                              "\nWhen you depart, set your survival to 0 after applying all bonuses.",
        "tenet": "All for One",
        "huntxp": [6,10,14],
        "type": "two",
        "flavor": "The Many-Headed Monster"
    },
    {
        "name": "Gourmandism",
        "neurosis": "Ravenous",
        "neurosisDefinition": "You may Activation to consume a piece of gear or resourse with the consumable keyward. Archive it."+
                              "\nDuring the Aftermath, if you did not perform this at least once this lantern year, suffer -1 strength.",
        "tenet": "Health",
        "huntxp": [6,10,14],
        "type": "two",
        "flavor": "You Are What You Eat"
    },
    {
        "name": "Optimism",
        "neurosis": "Important",
        "neurosisDefinition": "When you dpeart, if your total number of armor points (after all bonuses) is higher than each other departing survivor's, "+
                              "you are full of confidence. Gain survival up to the settlement's survival limit. Otherwise, lose all survival.",
        "tenet": "Positivity",
        "huntxp": [6,10,14],
        "type": "two",
        "flavor": "Life's Good"
    },
    {
        "name": "Regalism",
        "neurosis": "Inferiority Complex",
        "neurosisDefinition": "You feel inferior and must confirm this bias.\nYou many not depart if you have the highest strength among all departing survivors.",
        "tenet": "Find the Castle",
        "huntxp": [6,10,14],
        "type": "two",
        "flavor": "The Castle Awaits"
    },
    {
        "name": "Verminism",
        "neurosis": "Frailty",
        "neurosisDefinition": "No matter how protected you are, you know your insides are vulnerable. +1 systemic pressure.",
        "tenet": "Hissing Arms",
        "huntxp": [6,10,14],
        "type": "two",
        "flavor": "A Kingdom Below"
    },
    {
        "name": "Ambitionism",
        "neurosis": "Spoiled",
        "neurosisDefinition": "If you are a returning survivor and collective cognition did not increase during the Aftermath, skip the next hunt and sulk."+
                              "\nPrivileged: Your tenet knowledge will be determined by the Rank 1 result in this book.",
        "tenet": null,
        "huntxp": [6,10,14],
        "type": "three",
        "flavor": "Thrive"
    },
    {
        "name": "Champion",
        "neurosis": "Compelled",
        "neurosisDefinition": "An internal need guides you to greatness. You must depart if able to do so. If you are unable to depart for any reason "+
                              "(you are retired, must skip the next hunt, etc.), you depart anyway, but set your insanity and survival to 0.",
        "tenet": "Chosen",
        "huntxp": [4,6,12],
        "type": "three",
        "flavor": "Stories and Tall Tales"
    },
];


export default philosophy;